<template>
        <div style="position: relative; margin-bottom: 0.3rem; font-size: 0.9rem;">
            <!--<transition name="fade2">-->
            <!--<div v-if="info" class="rollover wh100" layout="row center-center">-->
            <!--<div class="info-label" self="bottom">-->
            <!--<strong>{{year}}</strong> // {{title}}-->
            <!--</div>-->
            <!--</div>-->
            <!--</transition>-->
            <router-link :to="createLink(link)">
                <img v-if="link" ref="thumb" class="thumbnail" :src="createThumbUrl(link)" @load="onLoaded()" v-show="loaded"/>
            </router-link>
            <div class="label"><strong class="year">{{year}}</strong> {{title}}</div>
        </div>

</template>

<script>

    export default {
        name: "thumbnail",
        data() {
            return {
                loaded: false,
                info: false,
            }
        },
        mounted() {
            if (this.title) {
                this.$emit('init');
            }
        },
        methods: {
            createLink(link) {
                if (link == undefined) return '/';
                return `/project/${link}`;
            },
            createThumbUrl(link) {
                // if (link == undefined) return '/';
                return `/static/projects/${link}/thumb.jpg`;
            },
            onLoaded() {
                this.loaded = true;
                this.$emit('loaded');
            }
        },
        props: ['title', 'link', 'year']
    }
</script>

<style lang="scss" scoped>
    .fade-enter-active {
        transition: opacity 0.8s ease-in-out;
    }

    .fade-enter-to {
        opacity: 1;
    }

    .fade-enter {
        opacity: 0;
    }

    .fade2-enter-active {
        transition: opacity 0.2s ease-in-out;
    }

    .fade2-enter-to {
        opacity: 1;
    }

    .fade2-enter {
        opacity: 0;
    }

    a:after {
        content: "";
    }

    .thumb {
        border-radius: 0.8rem;
        padding: 2px;

    }

    .rollover {
        position: absolute;
        color: white;
        pointer-events: none;
        padding: 1rem;
    }

    .info-label {
        background-color: rgba(0, 0, 0, 0.5);
        padding: 0.3rem 0.6rem 0.3rem 0.6rem;
        border-radius: 0.3em;
        font-size: 1.2rem;
    }

    .year {
        @media screen and (max-width: 800px) and (min-width: 400px) {
           // display: none;
        }
        @media screen and (max-width: 400px) {

        }
    }

    .label {
        @media screen and (max-width: 830px) and (min-width: 400px) {
            font-size: 0.7rem;
        }

    }

</style>
